export default {
    config: {},
    adminDisplay: false,
    adminOnlyMode: false,
    selfRegistration: false,
    conferenceEnabled: false,
    sidePanelSearchTerm: '',
    settings: {},
    floorPlanTransforms: {},
    currentFloorId: '',
    backUpFloorId: -1,
    pinnedOffices: [],
    maxOccupancy: {},
    themes: [],
    currentUserId: null,
    userList: [],
    conferenceList: null, // when it's empty at least we know it completed
    partnerPartyList: null,
    unfilteredUserList: [],
    floors: null,
    unfilteredFloors: [],
    departments: [],
    moveElevator: true, // animate the elevator to "currentFloor"
    rooms: null,
    meetingConfig: {
        meetingInProgress: false,
        meetingStarting: false
    },
    nativeNotifications:[],
    showTour: true,
    noPopup: false,
    missedNotificationCount: [],
    waitingRoomEnabled: true,
    elevatorLettersEnabled: false
};
